import type { EcommerceEventParams } from "./e-commerce-event";
import type { EcommerceItem } from "./item-schema";

/**
 * Which conversion funnel an e-commerce event belongs to.
 *
 * Subscription checkout events are remapped to the standard GA4 names
 * (`begin_checkout`, `purchase`, ...) before they are sent, so without this
 * property the cart and subscription funnels are indistinguishable in
 * analytics.
 */
export type EcommerceFunnel = "cart" | "subscription";

const SUBSCRIPTION_ITEM_CATEGORIES: ReadonlySet<
  EcommerceItem["item_category"]
> = new Set(["Abonnement", "Medlemskap"]);

export function getEcommerceFunnel(
  eventParams: Pick<EcommerceEventParams, "eventName">,
  items: Pick<EcommerceItem, "item_category">[] = [],
): EcommerceFunnel | undefined {
  switch (eventParams.eventName) {
    case "subscription_begin_checkout":
    case "subscription_add_shipping_info":
    case "subscription_add_payment_info":
    case "subscription_purchase":
      return "subscription";
    case "add_to_cart":
    case "remove_from_cart":
    case "view_cart":
    case "begin_checkout":
    case "add_shipping_info":
    case "add_payment_info":
    case "purchase":
      return "cart";
    case "view_item":
    case "select_item":
      if (items.length === 0) return undefined;
      return items.every((item) =>
        SUBSCRIPTION_ITEM_CATEGORIES.has(item.item_category),
      )
        ? "subscription"
        : "cart";
    default:
      return undefined;
  }
}
